import React, { useState } from "react";
import { ProgressBar } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { fetchEventMatchQualityEventsAsync } from "../../helpers/reports/getTrackerReports";
import "./popup.css";
import SwalAlertComp from "../../components/SwalAlert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHourglassHalf, faCircle } from "@fortawesome/free-solid-svg-icons";

const EventMatchQualityPopup = ({ quality, eventName, pixelId, rating }) => {
    const [show, setShow] = useState(false);
    const [customerInfo, setCustomerInfo] = useState([]);

    const handleClose = () => setShow(false);
    const handleShow = async () => {
        if (quality !== "-") {
            setShow(true);
            let response = await fetchEventMatchQualityEventsAsync(
                pixelId,
                eventName,
            );
            if (response.status) {
                setCustomerInfo(response?.data ?? "");
            } else {
                SwalAlertComp({
                    title: language?.delete_swal_modal?.failed ?? "Failed",
                    message: response?.message,
                    icon: "error",
                    timer: 3000,
                });
            }
        }
    };
    const language = useSelector((state) => state.languagesState.languages);
    return (
        <div>
            <p className="qaheader" onClick={handleShow}>
                {quality == "none" ? (
                    <FontAwesomeIcon
                        icon={faHourglassHalf}
                        className="force16px"
                    />
                ) : quality == "ok" ? (
                    <FontAwesomeIcon
                        icon={faCircle}
                        className="coloredIcon pb-1"
                    >
                        <span className="forceWhite px-2">
                            {language?.implementationGuide_page?.okay ?? "Okay"}
                        </span>
                    </FontAwesomeIcon>
                ) : quality == "-" ? (
                    quality
                ) : (
                    <FontAwesomeIcon
                        icon={faCircle}
                        className="coloredIcon pb-1"
                    >
                        <span className="forceWhite px-2">
                            {quality.replace(/^\w/, (c) => c.toUpperCase())}
                        </span>
                    </FontAwesomeIcon>
                )}
            </p>

            <Modal
                size="lg"
                show={show}
                onHide={handleClose}
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <strong className="p-3">
                            {language?.implementationGuide_page
                                ?.event_matching ?? "Event Matching"}
                        </strong>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row baseContainer">
                        <div className="col-12 col-xs-9 col-lg-9">
                            <div className="eventDivBorder mb-2">
                                <div className="row d-flex justify-content-between align-items-center p-3">
                                    <div className="col-6">
                                        <div className="h2 font-weight-bold popupCurrentlyTitle">
                                            {quality == "none"
                                                ? "Currently unavailable"
                                                : quality == "ok"
                                                  ? "Okay"
                                                  : quality.replace(
                                                        /^\w/,
                                                        (c) => c.toUpperCase(),
                                                    )}
                                        </div>
                                        <div className="d-flex">
                                            <div
                                                className={
                                                    "span1 mr-1 rounded-left " +
                                                    (quality == "Poor" ||
                                                    quality == "poor"
                                                        ? "makeRed"
                                                        : quality == "Okay" ||
                                                            quality == "ok"
                                                          ? "makeOrange"
                                                          : quality == "Good" ||
                                                              quality ==
                                                                  "Great" ||
                                                              quality ==
                                                                  "good" ||
                                                              quality == "great"
                                                            ? "makeGreen"
                                                            : "")
                                                }
                                            ></div>
                                            <div
                                                className={
                                                    "span1 mr-1 " +
                                                    (quality == "Okay" ||
                                                    quality == "ok"
                                                        ? "makeOrange"
                                                        : quality == "Good" ||
                                                            quality ==
                                                                "Great" ||
                                                            quality == "good" ||
                                                            quality == "great"
                                                          ? "makeGreen"
                                                          : "")
                                                }
                                            ></div>
                                            <div
                                                className={
                                                    "span1 mr-1 " +
                                                    (quality == "Good" ||
                                                    quality == "Great" ||
                                                    quality == "good" ||
                                                    quality == "great"
                                                        ? "makeGreen"
                                                        : "")
                                                }
                                            ></div>
                                            <div
                                                className={
                                                    "span1 mr-1 rounded-right " +
                                                    (quality == "Great" ||
                                                    quality == "great"
                                                        ? "makeGreen"
                                                        : "")
                                                }
                                            ></div>
                                        </div>
                                    </div>
                                    <div
                                        className={
                                            "col-2 d-flex justify-content-center font-weight-bold ratingClass " +
                                            (quality == "Poor" ||
                                            quality == "poor"
                                                ? "makeRed"
                                                : quality == "Okay" ||
                                                    quality == "ok"
                                                  ? "makeOrange"
                                                  : quality == "Good" ||
                                                      quality == "Great" ||
                                                      quality == "good" ||
                                                      quality == "great"
                                                    ? "makeGreen"
                                                    : "")
                                        }
                                    >
                                        {rating && rating}/10
                                    </div>
                                </div>
                                <p className="p-3">
                                    {language?.implementationGuide_page
                                        ?.compared_to_other_advertisers ??
                                        `Compared to other advertisers in the same region, the customer information you’re sending with ${eventName} events is only somewhat effective at matching the events to a Meta account.This limits your ability to show relevant ads to people.`}
                                </p>
                            </div>
                            <div className="eventDivBorder">
                                <div>
                                    <div className="mb-4">
                                        <h2>
                                            {language?.implementationGuide_page
                                                ?.coverage ?? "Coverage"}
                                        </h2>
                                        <p>
                                            {language?.implementationGuide_page
                                                ?.review_the_customer ??
                                                "Review the Customer information you've added to this event and address any active diagnostics issues."}
                                        </p>
                                    </div>
                                    <div>
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">
                                                        {language
                                                            ?.implementationGuide_page
                                                            ?.costomer_information ??
                                                            "Costomer Information Received"}
                                                    </th>
                                                    <th scope="col"></th>
                                                    <th scope="col">
                                                        {language
                                                            ?.implementationGuide_page
                                                            ?.percent_of_events ??
                                                            "Percent of Events Sending"}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {customerInfo.length > 0 &&
                                                    customerInfo.map((item) => (
                                                        <tr>
                                                            <td>{item.name}</td>
                                                            <td></td>
                                                            <td>
                                                                <strong>
                                                                    %
                                                                    {
                                                                        item.percentage
                                                                    }
                                                                </strong>
                                                                <ProgressBar
                                                                    variant={
                                                                        item.percentage <
                                                                        25
                                                                            ? "danger"
                                                                            : item.percentage >
                                                                                    25 &&
                                                                                item.percentage <
                                                                                    50
                                                                              ? "primary"
                                                                              : item.percentage >
                                                                                  50
                                                                                ? "success"
                                                                                : null
                                                                    }
                                                                    now={
                                                                        item.percentage
                                                                    }
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-xs-3 col-lg-3 eventDivBorder">
                            <div className="row">
                                <div className="col-12">
                                    <h2 className="py-2">
                                        {language?.implementationGuide_page
                                            ?.recommendation ??
                                            "Recommendation"}
                                    </h2>
                                    <p className="py-2">
                                        {language?.implementationGuide_page
                                            ?.start_sending_the ??
                                            `Start sending the following customer information parameters with ${eventName} events to help improve event match quality.`}
                                    </p>
                                </div>
                            </div>
                            <div className="row py-2">
                                <div className="col-12">
                                    {language?.implementationGuide_page
                                        ?.improving_your_event ??
                                        "Improving your event match quality can help you see more conversions and lower your cost per result."}
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        color="error"
                        variant="contained"
                        onClick={handleClose}
                    >
                        {language?.buttons?.close ?? "Close"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default EventMatchQualityPopup;
